// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stockList":"stockList-1-tTrm41","red":"red-wbDg1l4u","current":"current-3bVeSIm_"};